import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_GENERAL_SETTINGS_ROUTE_NAME } from '@modules/general-settings/constants';
import {
  ADMIN_GENERAL_SETTINGS_AUTO_APPROVE_PERMISSIONS,
  ADMIN_GENERAL_SETTINGS_AUTO_APPROVE_ROUTE_NAME,
  TRANSLATION_GROUP_GENERAL_SETTINGS_AUTO_APPROVE,
} from '@modules/general-settings/submodules/auto-approve/constants';
import { useI18n } from '@modules/i18n/composables';

import { getTranslationKeys } from './translations';

export class AdminGeneralSettingsAutoApproveModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_AUTO_APPROVE_ROUTE_NAME,
      path: 'auto_approve',

      component: () => import('@modules/general-settings/submodules/auto-approve/pages/AdminGeneralSettingsAutoApprovePage/AdminGeneralSettingsAutoApprovePage.vue'),
      permission: ADMIN_GENERAL_SETTINGS_AUTO_APPROVE_PERMISSIONS.AUTOAPPROVELOCALES_SHOW,
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      caption: getTPath(TRANSLATION_GROUP_GENERAL_SETTINGS_AUTO_APPROVE, 'TAB_NAME'),
      to: {
        name: ADMIN_GENERAL_SETTINGS_AUTO_APPROVE_ROUTE_NAME,
      },
      permission: ADMIN_GENERAL_SETTINGS_AUTO_APPROVE_PERMISSIONS.AUTOAPPROVELOCALES_SHOW,
      id: ADMIN_GENERAL_SETTINGS_AUTO_APPROVE_ROUTE_NAME,
      order: 20,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_GENERAL_SETTINGS_AUTO_APPROVE, getTranslationKeys);
  }
}
